<p-inputIcon [styleClass]="styleClass">
  <ng-content />
</p-inputIcon>

<osp-input-help-text [helpText]="helpText"></osp-input-help-text>
